import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type DeleteCurrentUserRequestBody = {
  reason?: string;
};

export const deleteCurrentUser = async ({ body }: BodyRequest<DeleteCurrentUserRequestBody>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.user.delete, body);
